import { render, staticRenderFns } from "./BtnDescomprometerSelecionados.vue?vue&type=template&id=58b6c488"
import script from "./BtnDescomprometerSelecionados.vue?vue&type=script&lang=js"
export * from "./BtnDescomprometerSelecionados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports